
import BaseDomainService from "./baseDomainServices";

const searchHistoryList = {
  searchText: ""
}
export default class UserDomainServices extends BaseDomainService {

  // API Get
  getList = this.apiService.appUserDetailServices.GetAllUserListByClientIdAndClientSecret;

  //Table Grid columns
  gridColmns = [
    { name: "userName", title: "User Name" },
    { name: "roleName", title: "Role Name" },
    { name: "isActive", title: "IsActive" }
  ];

  SearchformFields = [
    {
      inputType: "text",
      placeholder: "Search By UserName",
      fieldName: "searchText",
      labelStyleName: 'none'
    },
  ]

  // Define the state variables
  dataItem;

  constructor() {
    super();
    this.actionActive = "isActive";
    this.onPaginationUpdate = this.onGetUsers.bind(this);
    this.dataItem = { ...searchHistoryList };
  }

  //** API Calls
  onGetUsers = (request) => {
    this.apiService.onAPICall(
      "getAllUserListByClientIdAndClientSecret",
      this.getList,
      request,
      this.onAPIResponse,
      this.onUpdateState
    );
  };

  onRedirectoList = () => {
    this.onRedirect("/AppUserList");
  };

  onRedirectoDashboard = () => {
    this.onRedirect("/Dashboard");
  };

  onAPIResponse = (key, isSuccess, responseData) => {
    if (!isSuccess) {
      this.onUpdateState({ setIsLoad: false });
      return;
    }
    switch (key) {
      case "getAllUserListByClientIdAndClientSecret":
        this.onUpdateState({
          dataList: responseData.itemList,
          TotalCount: responseData.totalCount,
          setIsLoad: false,
        });
        break;

      default:
        // Handle default case here
        break;
    }
  };
}
